/* projects/speaker-platform/src/app/molecules/post-states/post-states.component.scss */
.poststates__postloader {
  display: inline-block;
  transform: scale(1.5);
}
.poststates__postingover {
  text-align: center;
}
.poststates__postingover__checkmark {
  color: #289526;
  font-size: 48px;
  margin-bottom: 16px;
}
.poststates__postingerror {
  text-align: center;
}
.poststates__postingerror__crossmark {
  color: #952626;
  font-size: 48px;
  margin-bottom: 16px;
}
/*# sourceMappingURL=post-states.component-WRT5JAN4.css.map */
